export type ScheduledDeliveryStatus = 'pending' | 'completed' | 'failed' | 'canceled'

export interface ScheduledDeliveryProps {
  uuid: string
  sendingScheduleUUID: string
  advertUUID: string
  channelUUID: string
  telegramAccountUUID: string
  accountId: number
  status: ScheduledDeliveryStatus
  jobId: number
  plannedAt: Date
  createdAt: Date
}

export class ScheduledDeliveryEntity {
  private readonly props: ScheduledDeliveryProps
  private constructor(props: ScheduledDeliveryProps) { this.props = { ...props } }
  static create(props: ScheduledDeliveryProps) { return new ScheduledDeliveryEntity(props) }
  get uuid() { return this.props.uuid }
  get sendingScheduleUUID() { return this.props.sendingScheduleUUID }
  get advertUUID() { return this.props.advertUUID }
  get channelUUID() { return this.props.channelUUID }
  get telegramAccountUUID() { return this.props.telegramAccountUUID }
  get accountId() { return this.props.accountId }
  get status() { return this.props.status }
  get jobId() { return this.props.jobId }
  get plannedAt() { return this.props.plannedAt }
  get createdAt() { return this.props.createdAt }
}
